export default function eikaSidemenu(menuContainer: HTMLElement) {
    if (!menuContainer) return;

    const triggerButtons = menuContainer.querySelectorAll('.sidemenu-item__button') as NodeListOf<HTMLButtonElement>;
    const triggerText = menuContainer.querySelectorAll('.sidemenu-item__link--trigger') as NodeListOf<HTMLSpanElement>;
    const toggleDisplayButton = document.querySelector('#toggle-sidemenu') as HTMLAnchorElement;
    let currentDisplayWidth = window.innerWidth;

    if (toggleDisplayButton) {
        toggleDisplayButton.addEventListener('click', (e: Event) => {
            if (menuContainer.hasAttribute('aria-hidden') && menuContainer.getAttribute('aria-hidden') === 'true') {
                menuContainer.setAttribute('aria-hidden', 'false');
            } else {
                menuContainer.setAttribute('aria-hidden', 'true');
            }
            e.preventDefault();
        });
    }

    if (!triggerButtons) return;

    const toggleSubMenus = (e: Event): void => {
        const expandEl = (e.target as HTMLElement).closest('.sidemenu-item') as HTMLLIElement;
        if (expandEl !== null) {
            expandEl.classList.toggle('sidemenu-item--active');
        }
        e.preventDefault();
    };

    const setContainerVisibility = (): void => {
        if (window.matchMedia('(max-width: 768px)').matches) {
            menuContainer.setAttribute('aria-hidden', 'true');
        } else {
            menuContainer.setAttribute('aria-hidden', 'false');
        }
    };

    triggerButtons.forEach((btn: HTMLButtonElement) => {
        btn.addEventListener('click', toggleSubMenus);
    });

    if (triggerText) {
        triggerText.forEach((el) => {
            el.addEventListener('click', toggleSubMenus);
        });
    }

    setContainerVisibility();
    window.addEventListener('resize', () => {
        if (window.innerWidth !== currentDisplayWidth) {
            currentDisplayWidth = window.innerWidth;
            setContainerVisibility();
        }
    });
    window.addEventListener('orientationchange', setContainerVisibility);
}
